/**
 * Legacy onboarding route.
 *
 * The customer-facing experience moved to `/app/implementation` (Sprint 1
 * of the Implementation Experience). This file exists only to redirect
 * old bookmarks / session-recovery URLs.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/onboarding")({
  beforeLoad: () => {
    throw redirect({ to: "/app/implementation" });
  },
});
